<template>
  <b-container class="container-rda">
    <b-row>
      <b-col>
        <Breadcrumb :breadcrumb="breadcrumb" />
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <h2 class="purple bold">Registro de aviso</h2>
      </b-col>
    </b-row>

    <b-row class="teacher-profile mt-50">
      <b-col>
        <b-row>
          <b-col>
            <b-form-group description>
              <label for="label">Título</label>
              <b-form-input
                v-model="notification.title"
                type="text"
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col>
            <b-form-group description>
              <label for="label">Url</label>
              <b-form-input
                v-model="notification.url"
                type="text"
              ></b-form-input>
              <a
                target="_blank"
                v-if="notification.url"
                :href="notification.url"
                style="text-decoration: underline; color: #b23066"
                >Testar Link</a
              >
            </b-form-group>
          </b-col>

          <b-col>
            <b-form-group class="required" description>
              <label for="label">Disponível até</label>
              <b-form-input
                v-model="notification.available_until"
                type="date"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-form-group class="required" description>
              <label for="label">Descrição</label>
              <b-form-textarea
                v-model="notification.description"
                type="textarea"
                placeholder
                required
              ></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>

        <label class="required" for="label">Destinatários</label>
        <b-row>
          <b-col>
            <SelectSimple
              v-model="selectedTarget"
              :options="targetsOptions"
              :callback="selectTargets"
            />
          </b-col>
          <b-col v-if="allCycles.length && isSubject">
            <SelectSimple
              :callback="selectSubject"
              :options="allCycles"
              v-model="selectedCycle"
            />
          </b-col>
          <b-col>
            <select-multiple
              v-if="
                selectedTargetDetailsOptions &&
                selectedTargetDetailsOptions.length > 0
              "
              :callback="selectTargetsDetails"
              :options="selectedTargetDetailsOptions"
              :hasSelectAll="false"
              :initial="selectedTargetDetails"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-row align-v="center" class="mt-5">
      <b-col class="text-right">
        <b-button
          :disabled="loading"
          class="large blue outline"
          :to="{
            name: 'notifications',
          }"
          >Voltar</b-button
        >

        <b-button
          :disabled="!formFilled || loading"
          @click="submit"
          class="large blue"
          ><b-spinner v-if="loading" variant="success" label="Aguarde!">
          </b-spinner>
          <span v-else>Criar aviso</span></b-button
        >
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import httpRda from "../../../http-rda.js";
import SelectSimple from "@/components/inputs/SelectSimple.vue";
import SelectMultiple from "@/components/inputs/SelectMultiple.vue";

export default {
  name: "updateEvent",
  components: {
    SelectSimple,
    SelectMultiple,
  },

  data() {
    return {
      formFilled: false,
      loading: false,
      notification: null,
      isSubject: false,
      allCycles: [],
      selectedCycle: null,
      targets: [],
      attachment: null,
      file: null,
      targetsOptions: [
        { id: "Cycle", label: "Ciclos" },
        { id: "Classroom", label: "Turmas" },
        { id: "Subject", label: "Disciplinas" },
        { id: "Student", label: "Alunos" },
        { id: "Responsible", label: "Responsáveis" },
        { id: "User", label: "Usuários" },
      ],
      targetsValues: null,
      selectedTarget: null,

      targetDetails: null,
      selectedTargetDetails: null,
      selectedTargetDetailsOptions: null,

      breadcrumb: [
        {
          text: "Administração",
          href: "/administracao",
        },
        {
          text: "Avisos",
          href: "/administracao/notificações",
        },
        {
          text: "Registro de aviso",
          href: "novosusuario",
          active: true,
        },
      ],
    };
  },
  watch: {
    notification: {
      handler: function (newEvent) {
        this.updateFormFilled(newEvent, this.targets);
      },
      deep: true,
    },
    selectedTargetDetails: {
      handler: function (newTargets) {
        this.updateFormFilled(this.notification, newTargets);
      },
      deep: true,
    },
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
  },

  methods: {
    updateFormFilled(notification, targets) {
      this.formFilled =
        notification.description &&
        notification.available_until &&
        notification.title &&
        targets.length > 0;
    },

    getEvent() {
      this.notification = {
        title: "",
        description: "",
        available_until: "",
        url: "",
      };
    },

    async submit() {
      try {
        this.loading = true;
        const payload = { ...this.notification, targets: this.targets };

        await httpRda.post(`/application-notifications`, payload);

        this.loading = false;
        this.$router.push({ name: "notifications" });
      } catch (error) {
        alert(error);
      }
    },

    async selectTargets(params) {
      this.selectedTarget = params;
      this.selectedTargetDetails = [];
      this.isSubject = false;

      switch (this.selectedTarget.label) {
        case "Ciclos":
          this.targetDetails = await httpRda
            .get("/cycles")
            .then((response) => response.data.cycles);

          this.selectedTargetDetailsOptions = this.targetDetails.map(
            (item) => ({ id: item.id, name: item.designation })
          );

          break;

        case "Turmas":
          this.targetDetails = await httpRda
            .get("/classrooms?include=Students")
            .then((response) => response.data.classrooms);

          this.selectedTargetDetailsOptions = this.targetDetails.map(
            (item) => ({ id: item.id, name: item.designation })
          );

          break;

        case "Disciplinas":
          this.isSubject = true;
          this.allCycles = await httpRda.get("/cycles").then((response) => {
            return response.data.cycles.map((item) => ({
              label: item.designation,
              id: item.id,
            }));
          });

          break;

        case "Alunos":
          this.targetDetails = await httpRda
            .get("/students?is_active=true")
            .then((response) => response.data.students);

          this.selectedTargetDetailsOptions = this.targetDetails.map(
            (student) => ({
              id: student.User.id,
              name: student.User.name,
            })
          );

          break;

        case "Responsáveis":
          this.targetDetails = await httpRda
            .get("/index-responsibles")
            .then((response) => response.data.responsibles);

          this.selectedTargetDetailsOptions = this.targetDetails.map(
            (responsible) => ({
              id: responsible.user_id,
              name: responsible.user_name,
            })
          );

          this.selectedTargetDetailsOptions.unshift({
            id: "todos",
            name: "Todos",
          });

          break;

        case "Usuários":
          this.targetDetails = await httpRda
            .get("/users?limit=false")
            .then((response) => response.data.users);

          this.selectedTargetDetailsOptions = this.targetDetails.map((user) => {
            return {
              id: user.id,
              name: user.name,
            };
          });

          this.selectedTargetDetailsOptions.unshift({
            id: "todos",
            name: "Todos",
          });

          break;
        default:
          break;
      }
    },

    async selectTargetsDetails(params) {
      if (params[0].id === "todos") {
        this.selectedTargetDetails = params;
        this.targets = [];
        this.targets.push({
          [this.selectedTarget.id]: params[0].id,
        });
      } else {
        this.selectedTargetDetails = params;
        this.targets = [];
        this.targets.push({
          [this.selectedTarget.id]: this.selectedTargetDetails.map(
            (item) => item.id
          ),
        });
      }
    },

    async selectSubject(params) {
      this.selectedCycle = params;
      this.selectedTargetDetails = [];
      await httpRda
        .get(`cycles/${params.id}?include=subjects`)
        .then((response) => {
          this.selectedTargetDetailsOptions = response.data.cycle.Subjects.map(
            (item) => ({ id: item.id, name: item.designation })
          );
        });
    },
  },

  created() {
    this.getEvent();
  },
};
</script>

<style lang="scss">
.teacher-profile {
  .form-group {
    &.required {
      &:after {
        right: 0;
      }
    }
  }
}

.table-students {
  width: 100%;

  td,
  th {
    font-size: 18px;
  }

  th {
    padding-bottom: 20px;
  }

  td {
    padding: 20px 0;
  }

  tr td:last-of-type {
    text-align: right;

    .actions {
      span {
        cursor: pointer;
      }

      .deleteStudent {
        margin-left: 30px;
      }
    }
  }

  tr + tr {
    border-bottom: 1px solid $grey5;
  }
}

.title-collapse {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;

  h5 {
    flex: 1;
  }

  .btn {
    background: transparent;
    border: 0;

    svg {
      font-size: 16px;
      fill: red;
    }
  }
}

.wrap-tags {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 10px;

  span {
    background-color: #efefef;
    padding: 4px 8px;
    border-radius: 4px;
    box-sizing: border-box;
  }
}

.wrap-button {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 6px;
}

.tag {
  background-color: #68c5b7;
  border-radius: 5px;
  color: #ffffff;
  font-weight: 700;
  line-height: 28px;
  margin: 3px 12px 3px 0;
  padding: 0 3px;
  padding-left: 8px;
  padding-right: 8px;
  text-align: center;
  vertical-align: middle;
  max-width: 100%;
}

.container-rda .multiselect__tag-icon:after {
  color: white;
}

input.isInvalid {
  border-color: red;
}
</style>
